<template>
  <div
    v-track="$trackMap.categoryArea.clickFeedGood"
    v-expose-track="{
      category_area: 'feedGood'
    }"
    class="item"
    @click="goDetail"
  >
    <div class="img-wrapper">
      <GoodImage
        :img-url="good.img_url | ossImage(200, 200, 'contain') | ossHttpVersion"
        :width="'3.48rem'"
        :height="'3.2rem'"
        :fit="'contain'"
      ></GoodImage>
    </div>
    <div class="ssu-info">
      <div class="name">
        {{ good.name }}
      </div>
      <div v-if="ssuFormatMessage" class="format-desc">
        {{ ssuFormatMessage }}
      </div>
      <!-- 标签列表 -->
      <div v-if="tagList.length" class="tag-list">
        <tag
          v-for="(tag, index) in tagList"
          :key="index"
          has-border
          has-background
          :primary-color="tag.text_color"
          :secondary-color="tag.frame_color"
          :corner-radius="tag.corner_radius"
          :bg-color="tag.background_color"
        >
          {{ tag.tag }}
        </tag>
      </div>
      <!-- 价格区域 -->
      <div class="price-area">
        <!-- 商品总价【针对226做灰度，合适可删掉】 -->
        <div
          v-if="
            ssu.total_price_with_fp && good.use_226_style && !good.price_shield
          "
          class="good-total-price"
        >
          {{ '￥' + ssu.total_price_with_fp }}
        </div>
        <!-- 【商品单价 [会员价 | 划线价] 加购按钮】 -->
        <div class="price-operator-wrap">
          <div v-if="!good.price_shield" class="price">
            <div class="sale">
              <span class="money">{{
                ssu.is_show_weight_unit_price === 1 ? '约￥' : '￥'
              }}</span>
              {{
                ssu.is_show_weight_unit_price === 1
                  ? ssu.weight_unit_price
                  : ssu.unit_price
              }}
              <span class="unit"
                >/{{
                  ssu.is_show_weight_unit_price === 1
                    ? ssu.weight_price_unit
                    : ssu.price_unit
                }}</span
              >
              <!-- <span v-if="hasPromote" class="origin">{{ ssuOriginPrice }}</span> -->
            </div>
          </div>
          <div v-else class="no-price">
            <p>{{ good.shield_text }}</p>
          </div>
          <div class="operater-wrapper">
            <operator
              use-simple
              show-simple-count
              :ssu="good.ssu_list[0]"
              :is-hint="good.is_hint"
              @add="addTick"
              @subscribe="subscribeTick"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Operator from '@/common/widgets/operator'
import Tag from '@/common/widgets/good_tag'
import GoodImage from '@/common/widget/GoodImage/index.vue'
export default {
  name: 'GoodsItem',
  components: {
    Operator,
    Tag,
    GoodImage
  },
  props: {
    good: {
      type: Object,
      default: () => ({})
    },
    goodIndex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ssu() {
      return this.good.ssu_list[0]
    },
    ssuFormatMessage() {
      // 针对226版本做字段灰度【下面的可以在之后的版本删掉】
      if (this.good.use_226_style) {
        return this.ssu.sku_ssu_format || ''
      }

      const ssu = this.ssu
      let ssuFormatMessage = ''
      // eslint-disable-next-line eqeqeq
      if (ssu.total_price_include_package != ssu.unit_price) {
        ssuFormatMessage +=
          '¥' + ssu.total_price_include_package + '/' + ssu.total_format
      } else {
        ssuFormatMessage += '每' + ssu.total_format
      }
      if (ssu.preposition_deposit_msg) {
        ssuFormatMessage += ssu.preposition_deposit_msg
      }
      return ssuFormatMessage
    },
    // 是否包含促销
    hasPromote() {
      // eslint-disable-next-line camelcase
      const promote_type = this.ssu.promote_type || []
      return (
        promote_type.includes(2) || // 普通商品2和购物车3是一个东西
        promote_type.includes(3) ||
        promote_type.includes(4) ||
        promote_type.includes(21) || // 会员价（标签展示），新增类型
        promote_type.includes(12)
      )
    },
    // 标签列表
    tagList() {
      return this.good.tags_list || []
    }
  },
  methods: {
    goDetail() {
      this.$nativeRedirect(this.$nativeRoutes.goodsDetail, {
        id: this.ssu.ssu_id
      })
    },
    addTick(ssu) {
      this.$track(this.$trackMap.categoryArea.addCart, {
        ssu_id: Number(ssu.ssu_id),
        sku_id: Number(ssu.sku_id),
        sku_pos: this.goodIndex
      })
    },
    subscribeTick(ssu) {
      this.$track(this.$trackMap.categoryArea.subscribe, {
        ssu_id: Number(ssu.ssu_id),
        sku_id: Number(ssu.sku_id)
      })
    }
  }
}
</script>
<style scoped lang="scss">
.item {
  position: relative;

  width: 3.44rem;
  margin-bottom: 0.16rem;
  overflow: hidden;

  background-color: #ffffff;

  border-radius: 0.16rem;

  .img-wrapper {
    position: relative;

    width: 100%;
    height: 3.2rem;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .ssu-info {
    position: relative;

    padding: 0.08rem 0.16rem 0.24rem;

    border-top: 1px solid #f6f6f6;

    .name {
      font-size: 0.28rem;
      line-height: 0.32rem;
      font-weight: bold;
      color: #262626;
      @include text-overflow-ellipsis-single;
    }

    .format-desc {
      margin-top: 0.04rem;

      font-size: 0.24rem;
      line-height: 0.28rem;
      color: #8c8c8c;
      @include text-overflow-ellipsis-single;
    }

    .tag-list {
      height: 0.32rem;
      margin-top: 0.16rem;
      overflow: hidden;

      @include flex(row, flex-start, flex-start, wrap);
    }

    .price-area {
      margin-top: 0.16rem;

      .good-total-price {
        margin-bottom: -0.06rem;

        font-size: 0.24rem;
        color: #595959;
      }
      .price-operator-wrap {
        @include flex(row, space-between, center, nowrap);

        .price {
          position: relative;

          font-size: 0.3rem;
          font-weight: normal;
          color: rgb(255, 97, 74);
          @include flex(row, flex-start, center, nowrap);

          .sale {
            display: flex;

            align-items: baseline;

            font-size: 0.32rem;

            font-weight: bold;
            color: #ff5c00;
          }
          .money {
            font-size: 0.2rem;
            font-weight: normal;
            color: inherit;
          }
          .unit {
            margin-left: 1px;

            font-size: 0.24rem;
            font-weight: normal;
            letter-spacing: 1px;
            color: $c-text-content-light;
          }

          .origin {
            margin-left: 0.04rem;

            font-size: 0.2rem;
            text-decoration: line-through;
            color: $c-text-content-light;
          }
        }

        .no-price {
          margin-top: 0.1rem;

          font-size: 10px;
          color: #999;
        }

        .operater-wrapper {
          flex: none;
        }
      }
    }
  }
}
</style>
